// extracted by mini-css-extract-plugin
export default {"Collapse":"AdsToLoadByAccountCollapse_Collapse__TpFmN"};